"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Refuges() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2364" id="friends-of-the-refuges" className="bg-background text-foreground relative w-full min-h-screen overflow-hidden">
      <div className="flex flex-col lg:flex-row w-full min-h-screen">
        {}
        <div ref={leftRef} className="relative w-full lg:w-[55%] h-[60vh] lg:h-screen overflow-hidden">
          <div className={`absolute inset-0 transition-opacity duration-[1800ms] ease-out ${leftVisible ? "opacity-100" : "opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/Dungeness-Protection Island.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/Dungeness-Protection Island.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/Dungeness-Protection Island.jpg-wvc-sizes" alt="Expansive view of Protection Island National Wildlife Refuge coastline" loading="eager" decoding="async" className="w-full h-full object-cover animate-[kenBurns_15s_ease-out_forwards] rounded-none" />
            {}
            <div className="pointer-events-none absolute inset-0" style={{
            background: "radial-gradient(ellipse at 15% 90%, hsla(160, 61%, 8%, 0.45) 0%, hsla(160, 61%, 8%, 0) 55%)"
          }} />
          </div>
        </div>

        {}
        <div ref={rightRef} className="relative w-full lg:w-[45%] min-h-[40vh] lg:min-h-screen bg-background flex items-center justify-center px-6 sm:px-10 lg:px-12 py-16 lg:py-0">
          <div className={`w-full lg:w-[80%] xl:w-[70%] max-w-xl mx-auto transition-all duration-[1400ms] ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="font-default text-primary uppercase" style={{
            fontSize: "11px",
            letterSpacing: "0.25em"
          }}>
              ADVOCACY · EST. MMXXIV
            </div>

            {}
            <h1 className="font-default text-foreground font-semibold mt-16 lg:mt-24" style={{
            fontSize: "clamp(3.5rem, 8vw, 7.5rem)",
            lineHeight: 1
          }}>Protecting our.<br /><span className="italic font-light" data-ast-id="f:/src/pages/Home/sections/Refuges.tsx|sig:fzbwj1" data-ast-start="3118" data-ast-end="3178">wildlife refuges.</span></h1>

            {}
            <p className="font-default text-foreground/80 mt-10 lg:mt-12" style={{
            fontSize: "17px",
            lineHeight: 1.7
          }}>
              Friends of the Refuges informs the public on how to protect our wildlife and sea bird refuges, particularly Protection Island and Dungeness National Wildlife Refuge.
            </p>

            {}
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8 mt-12 lg:mt-16">
              <Button asChild className="bg-primary text-white hover:bg-primary/90 rounded-lg px-8 h-12 text-xs tracking-[0.25em] uppercase font-default font-medium shadow-md">
                <Link to="/GetInvolvedPage">Get Involved</Link>
              </Button>

              <Link to="/OurMissionPage" className="group inline-flex items-center gap-2 font-default text-foreground text-sm tracking-wide">
                <span className="relative">
                  Learn about our mission
                  <span className="absolute left-0 -bottom-0.5 h-px w-full bg-foreground origin-left scale-x-100 sm:scale-x-0 sm:group-hover:scale-x-100 transition-transform duration-500 ease-out" />
                </span>
                <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          {}
          <div className="hidden lg:flex absolute bottom-10 right-10 flex-col items-center gap-3">
            <span className="font-default text-foreground/50 uppercase" style={{
            fontSize: "10px",
            letterSpacing: "0.3em",
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              SCROLL
            </span>
            <span className="block w-px h-12 bg-primary/40 animate-[scrollPulse_2.4s_ease-in-out_infinite] origin-top" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes kenBurns {
          0% { transform: scale(1); }
          100% { transform: scale(1.04); }
        }
        @keyframes scrollPulse {
          0%, 100% { transform: scaleY(0.6); opacity: 0.4; }
          50% { transform: scaleY(1); opacity: 0.8; }
        }
      `}</style>
    </section>;
}